import _ from '@/common/helpers';
import FILTER_TYPES from '@/components/query/filter-types';
import FILTER_SOURCE_TYPES from '@/components/query/filter-source-type';
import InvoiceModel from '@/common/models/invoice-model';

/* eslint-disable quote-props */
export default {
    id: 'invoices',
    version: 2,
    filterSpec: {
        invoiceNumber: {
            type: FILTER_TYPES.numeric,
        },
        'items.productId': {
            label: 'Product',
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'products',
                labelBuilder: ({id}) => `${_.truncate(id, {limit: 11, dots: true})}`,
                value: 'id',
            },
        },
        'items.planId': {
            label: 'Plan',
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'plans',
                labelBuilder: ({id}) => `${_.truncate(id, {limit: 11, dots: true})}`,
                value: 'id',
            },
        },
        'customer.tags': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'tags',
                labelBuilder: ({name}) => name,
                value: 'name',
            },
        },
        currency: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.currencies,
            },
        },
        amount: {
            type: FILTER_TYPES.numeric,
        },
        customerId: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'customers',
                labelBuilder: ({id, email}) => `${_.truncate(id, {limit: 11, dots: true})} - ${email}`,
                value: 'id',
            },
        },
        issuedTime: {
            label: 'Date Issued',
            type: FILTER_TYPES.datetime,
        },
        paidTime: {
            label: 'Payment Date',
            type: FILTER_TYPES.datetime,
        },
        status: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.enum,
                enum: Object.values(InvoiceModel.Status),
            },
        },
        type: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.enum,
                enum: Object.values(InvoiceModel.Type),
            },
        },
        id: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'invoices',
                labelBuilder: ({id}) => `${_.truncate(id, {limit: 11, dots: true})}`,
                value: 'id',
            },
        },
        websiteId: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'websites',
                labelBuilder: ({id}) => `${_.truncate(id, {limit: 11, dots: true})}`,
                value: 'id',
            },
        },
        organizationId: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'organizations',
                labelBuilder: ({id}) => `${_.truncate(id, {limit: 11, dots: true})}`,
                value: 'id',
            },
        },
        subtotalAmount: {
            type: FILTER_TYPES.numeric,
        },
        discountAmount: {
            type: FILTER_TYPES.numeric,
        },
        shippingAmount: {
            type: FILTER_TYPES.numeric,
        },
        'deliveryAddress.firstName': {
            type: FILTER_TYPES.text,
        },
        'deliveryAddress.lastName': {
            type: FILTER_TYPES.text,
        },
        'deliveryAddress.organization': {
            type: FILTER_TYPES.text,
        },
        'deliveryAddress.address': {
            type: FILTER_TYPES.text,
        },
        'deliveryAddress.address2': {
            type: FILTER_TYPES.text,
        },
        'deliveryAddress.city': {
            type: FILTER_TYPES.text,
        },
        'deliveryAddress.region': {
            type: FILTER_TYPES.text,
        },
        'deliveryAddress.country': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.countries,
            },
        },
        'deliveryAddress.postalCode': {
            type: FILTER_TYPES.text,
        },
        // Todo delivery names & emails
        'billingAddress.firstName': {
            type: FILTER_TYPES.text,
        },
        'billingAddress.lastName': {
            type: FILTER_TYPES.text,
        },
        'billingAddress.organization': {
            type: FILTER_TYPES.text,
        },
        'billingAddress.address': {
            type: FILTER_TYPES.text,
        },
        'billingAddress.address2': {
            type: FILTER_TYPES.text,
        },
        'billingAddress.city': {
            type: FILTER_TYPES.text,
        },
        'billingAddress.region': {
            type: FILTER_TYPES.text,
        },
        'billingAddress.country': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.countries,
            },
        },
        'billingAddress.postalCode': {
            type: FILTER_TYPES.text,
        },
        poNumber: {
            type: FILTER_TYPES.text,
        },
        autopayScheduledTime: {
            type: FILTER_TYPES.datetime,
        },
        autopayRetryNumber: {
            type: FILTER_TYPES.numeric,
        },
        delinquentCollectionPeriod: {
            type: FILTER_TYPES.numeric,
        },
        collectionPeriod: {
            type: FILTER_TYPES.numeric,
        },
        abandonedTime: {
            type: FILTER_TYPES.datetime,
        },
        voidedTime: {
            type: FILTER_TYPES.datetime,
        },
        dueTime: {
            type: FILTER_TYPES.datetime,
        },
        createdTime: {
            type: FILTER_TYPES.datetime,
        },
        updatedTime: {
            type: FILTER_TYPES.datetime,
        },
    },
};
